// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 10\"> <path fill=\"#41B883\" d=\"m7.2465.8001-1.247 2.0785L4.7525.8H.5995l5.3999 9 5.3998-9H7.2465Z\"/> <path fill=\"#34495E\" d=\"m7.2467.8001-1.247 2.0784L4.7527.8001h-1.993L5.9998 6.2 9.2396.8001H7.2467Z\"/> </svg>";
// Exports
module.exports = code;